import Button from '@mercell/button-react';
import {
    Modal,
    ModalTitle,
    ModalButtonsSection,
    ModalContent,
} from '@mercell/modal-react';
import { Ribbon } from '@mercell/ribbon-react';
import Tooltip from '@mercell/tooltip-react';
import React, { FC } from 'react';

interface ConfirmationModalProps {
    children: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    title?: string;
    text?: string;
    isModalVisible: boolean;
    isDisabled?: boolean;
    closeModal: () => void;
    onConfirm?: () => void;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
    confirmText,
    cancelText,
    title,
    text,
    isModalVisible,
    isDisabled = false,
    closeModal,
    children,
    onConfirm,
}) => (
    <Modal
        isModalVisible={isModalVisible}
        onCloseCallback={closeModal}
        style={{ overflow: 'scroll' }}
    >
        <ModalTitle>{title}</ModalTitle>
        <ModalContent>
            <div>{children}</div>
            <p className="text-center">{text}</p>
        </ModalContent>
        <ModalButtonsSection className="flex justify-end">
            {confirmText && (
                <Button
                    scheme="primary"
                    className="mr-2"
                    style={{ minWidth: 100 }}
                    onClick={onConfirm}
                    disabled={isDisabled}
                >
                    {confirmText}
                </Button>
            )}
            {cancelText && (
                <Button
                    scheme="secondary"
                    className="min-w-20"
                    style={{ minWidth: 100 }}
                    onClick={closeModal}
                >
                    {cancelText}
                </Button>
            )}
        </ModalButtonsSection>
    </Modal>
);

export default ConfirmationModal;
